<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link
          :to="`/businesses_change`"
          :key="`businesses`"
          :name="$store.state.text['change_school']"
          :icon="`ti-arrow-circle-left`"
        />

        <sidebar-link
          :to="`/dashboard`"
          :key="`dashboard`"
          :name="$store.state.text['main']"
        />
        <sidebar-link
          v-for="(route, key) in routes" v-if="route.id != 30"
          :to="`/${route.path}`"
          :key="key"
          :name="route.title"
        />
        <!-- <li class="nav-item nav-dropdown">
          <router-link
            class="nav-link"
            :to="`/summaryreports`"
            :key="`summaryreports`"
          > 
          <p>Движение учеников</p>
          </router-link>
          <span class="icon-angle" @click="openSub">
            <span class="ti-angle-down"></span>
          </span>
          <ul class="subnav">
            <li class="subnav-item">
              <router-link
                :to="`/summaryreports`"
                :key="`summaryreports`"
              >Сводка</router-link>
            </li>
          </ul>
        </li> -->
        <li class="nav-item">
          <a
            class="nav-link"
            :href="`https://kundalik.com/teachers`"
            target="_blank"
            ><p>KUNDALIK</p></a
          >
        </li>

        <sidebar-link
          :to="`/quit`"
          :key="`quit`"
          :name="$store.state.text['quit']"
        />
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["routes"]),
  },
  created(){
    // let obj = {
    //   "id": 26,
    //   "name": "SSSSS оплат",
    //   "title": "SSSSS оплат",
    //   "path": "jobspositions",
    //   "position": 35,
    //   "icon": null
    // }
    // console.log(this.$store.state.user)
    // if(this.$store.state.user.is_root === true){
    //   this.routes.push(obj)
    //   this.$store.dispatch("setRoutes", this.routes);
    //   console.log(this.routes, 'routes')
    // }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    openSub(event, aa){
      const el = event.target
      const parent = el.closest('.nav-dropdown')
      if(parent)
        parent.classList.toggle('open')
      console.log(el, parent)
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>

<style>
.logout {
  border: none;
  box-shadow: none;
  width: 100%;
  position: absolute;
  bottom: 30px;
  background: transparent;
  color: #fff;
  font-size: 20px;
  text-align: left;
  padding: 10px 25px;
}
</style>
